import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';
import { Endpoint } from './endpoint';

@Injectable()
export class EndpointService implements Resolve<any> {
  public rows: any;
  public onServiceListChanged: BehaviorSubject<any>;

  constructor(private _httpClient: HttpClient, public _authenticationService: AuthenticationService) {
    this.onServiceListChanged = new BehaviorSubject({});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return new Promise<void>((resolve, reject) => {
      Promise.all([this.getAllEndpoints()]).then(() => {
        resolve();
      }, reject);
    });
  }

  getAllEndpoints(ignoreSubjects = false): Promise<Endpoint[]> {
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.get(`${environment.apiUrl}/v1/endpoints`, { headers }).subscribe((response: any) => {
        this.rows = response.results;
        if (!ignoreSubjects) {
          this.onServiceListChanged.next(this.rows);
        }
        resolve(this.rows);
      }, reject);
    });
  }

  createEndpoint(endpoint): Promise<void> {
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.post(`${environment.apiUrl}/v1/endpoints`, endpoint, { headers }).subscribe((response: any) => {
        this.getAllEndpoints();
        resolve();
      }, reject);
    });
  }

  updateEndpoint(endpoint): Promise<void> {
    delete endpoint.ownedBy;
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.patch(`${environment.apiUrl}/v1/endpoints/${endpoint.id}`, endpoint, { headers }).subscribe((response: any) => {
        this.getAllEndpoints();
        resolve();
      }, reject);
    });
  }
}
